import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Automated Billing & Invoicing",
        description: "Automate your billing and invoicing processes to save time and reduce human errors.",
        imgUrl: "./img/services/finance-automation/automated-billing-invoicing.png",
    },
    {
        title: "Expense Management",
        description: "Track and manage expenses efficiently with automated workflows and reports.",
        imgUrl: "./img/services/finance-automation/expense-management.jpg",
    },
    {
        title: "Payroll Automation",
        description: "Simplify payroll processing with automated calculations and tax filings.",
        imgUrl: "./img/services/finance-automation/payroll-automation.jpg",
    },
    {
        title: "Financial Reporting",
        description: "Generate real-time financial reports and gain insights into your company’s performance.",
        imgUrl: "./img/services/finance-automation/financial-reporting.jpg",
    },
    {
        title: "Tax Compliance",
        description: "Ensure tax compliance with automated updates on tax laws and real-time tax calculations.",
        imgUrl: "./img/services/finance-automation/tax-compliance.jpg",
    },
    {
        title: "Bank Reconciliation",
        description: "Automate bank reconciliation to ensure accurate and up-to-date financial records.",
        imgUrl: "./img/services/finance-automation/bank-reconcilation.png",
    },
];

const FinanceAutomation = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Finance Automation", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Finance Automation" description="Transform your financial operations with our automation solutions designed to save time, reduce errors, and improve efficiency." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is Finance Automation?</h2>
                            <p>
                                Finance Automation involves using technology to automate financial tasks and processes that were traditionally performed manually. It helps streamline financial operations, reduce errors, improve accuracy, and allow businesses to focus more on strategic decision-making.
                            </p>
                            <img
                                src="./img/services/finance-automation.png"
                                alt="Finance Automation"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Finance Automation Solutions</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Finance Automation</h2>
                            <ul>
                                <li>
                                    <strong>Time Savings:</strong> Automate repetitive tasks and free up valuable time for strategic planning and growth.
                                </li>
                                <li>
                                    <strong>Increased Accuracy:</strong> Reduce human errors in financial records and transactions.
                                </li>
                                <li>
                                    <strong>Cost Efficiency:</strong> Lower operational costs by eliminating the need for manual data entry and paperwork.
                                </li>
                                <li>
                                    <strong>Real-Time Financial Insights:</strong> Access real-time data to monitor your financial health and make informed decisions.
                                </li>
                                <li>
                                    <strong>Improved Compliance:</strong> Ensure compliance with regulatory requirements by automating updates and calculations.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Transform Your Financial Operations Today</h2>
                            <p>
                                Discover how our Finance Automation solutions can help your business run more efficiently. <br />
                                Reach out to us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default FinanceAutomation;
